import { render, staticRenderFns } from "./ClockSectionHeader.vue?vue&type=template&id=29401062&scoped=true&"
import script from "./ClockSectionHeader.vue?vue&type=script&lang=js&"
export * from "./ClockSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29401062",
  null
  
)

export default component.exports